const autoNgTemplateLoaderTemplate1 = require('./azure-sidebar.html');

import angular from 'angular';

angular.module('shbdeployer.azure').component('azureSidebar', {
  templateUrl: autoNgTemplateLoaderTemplate1,
  bindings: {
    endpointId: '<',
  },
});
